import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function formatDataNoPhotos(user, insurance, stripeInfo) {
  return {
    "fname": user.firstName,
    "lname": user.lastName,
    "email": user.email,
    "phone": user.phoneNo,
    "pregnancyStatus": Array.from(user.sex.maternity),
    "menstrualCycle": user.sex.cycle,
    "additionalCycleDetails": user.sex.additional,
    "contraceptive": user.sex.contraceptive,
    "otherContraceptive": user.sex.otherContraceptive,
    "gender": user.sex.sexAtBirth,
    "dateOfBirth": dayjs.utc(user.dob).format("YYYY-MM-DD"),
    "addressLineOne": user.address.line1,
    "addressLineTwo": user.address.line2 ?? "",
    "city": user.address.city,
    "state": user.address.state,
    "zipCode": user.address.zip,
    "zipPlusFour": "", // TODO: use places API to query this
    "recentFormSubmittedAt": dayjs().format("YYYY-MM-DD"),
    "fields": null,
    "journeys": {},
    "assignedTo": null,
    "insurance": {
      "memberId": insurance.memberID,
      "payerName": insurance.insurer,
      "relationship": insurance.policyOwner.relationship,
      "relationshipDetails": {
        "fname": insurance.policyOwner.fname,
        "lname": insurance.policyOwner.lname,
        "gender": insurance.policyOwner.gender,
        "dateOfBirth": insurance.policyOwner.dob == null ? insurance.policyOwner.dob : dayjs(insurance.policyOwner.dob).format("YYYY-MM-DD"),
      },
      "cardFront": "",
      "cardBack": "",
    },
    "inStateForCare": user.inStateForCare,
    "guardian": user.parent,
    "duration": user.duration,
    "patientPhotos": [],
    "currentSymptoms": user.other,
    "currentPregnancyStatus": {
      "data": Array.from(user.sex.maternity),
    },
    "patientReportedRelatedMedications": user.prescriptions,
    "patientReportedMedications": user.otherMeds.meds,
    "hasPatientReportedMedications": user.otherMeds.has,
    "hasAllergies": user.allergies.has,
    "allergies": user.allergies.description,
    "medicalHistory": Array.from(user.tried),
    "patientReportedBodyParts": user.bodyPart,
    "weight": user.weight,
    "reference": user.hearAbt,
    "patientReportedConcern": user.concern,
    "paymentIntentID": stripeInfo.paymentIntentID,
    "clientSecret": stripeInfo.clientSecret,
    "customerID": stripeInfo.customerID,
    "paymentMethod": user.payMethod,
    "uberDoc": user.uberDoc,
    "zocDoc": user.zocDoc,
    "firefly": user.firefly,
    "patientHistory": user.patientHistory,
    "treatmentContinuation": user.treatmentContinuation,
    "birthControlMethods": user.sex.contraceptive,
    "lmpDate": user.sex.lmpDate,
    "otherBirthControl": user.sex.otherContraceptive,
    "adultWeight": user.adultWeight,
    "caseID": user.caseID,
    "skippedInsurance": user.skippedInsurance,
    "paid": user.paid,
    "imagesUploaded": user.imagesUploaded,
    "current_page": user.currentPage,
    "skippedPhotos": user.skippedPhotos
  };
}

export function formatUserIdentity(user) {
  return {
    "fname": user.firstName,
    "lname": user.lastName,
    "email": user.email,
    "phone": user.phoneNo,
    "dateOfBirth": dayjs(user.dob).format("YYYY-MM-DD"),
    "amount": user.returning ? 7900 : 11900,
    "patientID": user.patientID,
  };
}

export function formatDataNoPhotosReturning(user, insurance, stripeInfo) {
  return {
    "fname": user.firstName,
    "lname": user.lastName,
    "email": user.email,
    "phone": user.phoneNo,
    "gender": user.sex.sexAtBirth,
    "dateOfBirth": dayjs.utc(user.dob).format("YYYY-MM-DD"),
    "addressLineOne": user.address.line1,
    "addressLineTwo": user.address.line2 ?? "",
    "city": user.address.city,
    "state": user.address.state,
    "zipCode": user.address.zip,
    "zipPlusFour": "", // TODO: use places API to query this
    "recentFormSubmittedAt": dayjs().format("YYYY-MM-DD"),
    "fields": null,
    "journeys": {},
    "assignedTo": null,
    "insurance": {
      "memberId": insurance.memberID,
      "payerName": insurance.insurer,
      "relationship": insurance.policyOwner.relationship,
      "relationshipDetails": {
        "fname": insurance.policyOwner.fname,
        "lname": insurance.policyOwner.lname,
        "gender": insurance.policyOwner.gender,
        "dateOfBirth": insurance.policyOwner.dob == null ? insurance.policyOwner.dob : dayjs(insurance.policyOwner.dob).format("YYYY-MM-DD"),
      },
      "cardFront": insurance.cardFront,
      "cardBack": insurance.cardBack,
    },
    "inStateForCare": user.inStateForCare,
    "guardian": user.parent,
    "duration": user.duration,
    "patientPhotos": [],
    "currentSymptoms": user.other,
    "patientReportedRelatedMedications": [user.prescriptions],
    "patientReportedMedications": user.otherMeds.meds,
    "hasPatientReportedMedications": user.otherMeds.has,
    "hasAllergies": user.allergies.has,
    "allergies": user.allergies.description,
    "medicalHistory": Array.from(user.tried),
    "patientReportedBodyParts": user.bodyPart,
    "weight": user.weight,
    "reference": user.hearAbt,
    "patientReportedConcern": user.concern,
    "returningCondition": user.returningCondition,
    "pickedMedication": user.pickedMedication,
    "onPrescribedMedication": user.onPrescribedMedication === "" ? "no" : user.onPrescribedMedication,
    "howWellWorks": user.howWellWorks,
    "sideEffects": {
      "has": user.sideEffects.has,
      "description": user.sideEffects.description,
    },
    "whyStoppedMedication": user.whyStoppedMedication,
    "followUpCare": user.followUpCare,
    "questionsForDoctor": user.questionsForDoctor,
    "newPhotos": user.newPhotos,
    "pregnancyStatus": Array.from(user.sex.maternity),
    "menstrualCycle": user.sex.cycle,
    "additionalCycleDetails": user.sex.additional,
    "contraceptive": user.sex.contraceptive,
    "otherContraceptive": user.sex.otherContraceptive,
    "paymentIntentID": stripeInfo.paymentIntentID,
    "clientSecret": stripeInfo.clientSecret,
    "customerID": stripeInfo.customerID,
    "paymentMethod": user.payMethod,
    "patientHistory": user.patientHistory,
    "treatmentContinuation": user.treatmentContinuation,
    "birthControlMethods": user.sex.birthControlMethods,
    "lmpDate": user.sex.lmpDate,
    "otherBirthControl": user.sex.otherBirthControl,
    "adultWeight": user.adultWeight,
    "caseID": user.caseID,
    "previousCaseID": user.previousCaseID,
    "returningIntakeID": user.retIntakeID || null,
    "missingPatient": user.missingPatient,
    "skippedInsurance": user.skippedInsurance,
    "patientID": user.patientID,
    "current_page": user.currentPage,
    "missedDoses": user.missedDoses,
    "medicalHistoryChanges": user.medicalHistoryChanges,
    "newMedicationsSinceLastVisit": user.newMedicationsSinceLastVisit,
    "accutaneSideEffects": user.accutaneSideEffects,
    "isIsotretinoin": user.isIsotretinoin,
    "phq9": user.phq9,
    "mentalHealthTrigger": user.mentalHealthTrigger
  };
}

export const formatAssessmentText = (assessment) => {
  if (!assessment) return 'N/A';

  if (typeof assessment === 'string') {
    return assessment;
  }

  if (Array.isArray(assessment)) {
    return assessment.map(a => a.description).join(', ');
  }

  if (typeof assessment === 'object' && assessment.description) {
    return `${assessment.description}`;
  }

  return 'Invalid assessment format';
};

export const getAssessmentText = (currentCase) => {
  const { is_returning, is_insurance, assessment, np_assessment } = currentCase;

  if (is_returning) {
    if (is_insurance) {
      return assessment || np_assessment;
    } else {
      return assessment;
    }
  } else {
    if (is_insurance) {
      return np_assessment || assessment;
    } else {
      return assessment;
    }
  }
};

/**
 * Determines if a case is complete based on its status flags
 * @param {Object} caseItem - The case object
 * @returns {boolean} - True if the case is complete, false otherwise
 */
export const getChipStatus = (caseItem) => {
    if (caseItem.is_npa) {
        return caseItem.np_is_closed;
    }
    if (caseItem.is_insurance) {
        return (caseItem.is_closed && caseItem.np_is_closed);
    }
    return caseItem.is_closed;
};

export const hasData = (currentCase) => {
  if (!currentCase) return false;
  const { is_insurance, plan, np_plan, is_npa } = currentCase;

  if (is_npa) {
    return Boolean(np_plan);
  }

  if (is_insurance) {
    return Boolean(plan) && Boolean(np_plan);
  }
  return Boolean(plan);
};
